<section class="custom-box" *ngIf="isDataAvailable()">
<section  class="blue-theme"  *ngIf="color === 'pur'">
    <div class="col-lg-11  gst-section mb3  ">
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Tax Legislation.svg" class="img-fluid">
                </div> -->
                <!-- <span class="text-heading">Tax Legislation</span> -->
                <span *ngFor="let taxLeg of taxLegislationList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="taxLeg.contentType?.titleEn"
                        [textHi]="taxLeg.contentType?.titleHi"></cbic-static-text>
                </span>
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let taxLeg of taxLegislationList">
                        <a href="{{taxLeg.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="taxLeg.titleEn" [linkTextHi]="taxLeg.titleHi"
                                [linkEn]="taxLeg.path" [linkHi]="taxLeg.path"></cbic-link>
                    </li>
                </ul>
            </div>
            
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Onlines Services.svg" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Online Services</span> -->
                <span *ngFor="let onlineService of onlineServiceList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="onlineService.contentType?.titleEn"
                        [textHi]="onlineService.contentType?.titleHi"></cbic-static-text>
                </span>
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let onlineService of onlineServiceList">
                        <a href="{{onlineService.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="onlineService.titleEn" [linkTextHi]="onlineService.titleHi"
                                [linkEn]="onlineService.path" [linkHi]="onlineService.path"></cbic-link>
                    </li>
                </ul>
            </div>
            
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card   solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/service.png" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Services'Codes,<br>Abatement & Exemption</span> -->
                <span *ngFor="let codes of sericeCodes;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="codes.contentType?.titleEn"
                        [textHi]="codes.contentType?.titleHi"></cbic-static-text>
                </span>
                
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let codes of sericeCodes">
                        <a href="{{codes.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="codes.titleEn" [linkTextHi]="codes.titleHi"
                                [linkEn]="codes.path" [linkHi]="codes.path"></cbic-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-lg-11  gst-section">
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/GSTIcon.svg" class="img-fluid"> </div> -->
               
                <span *ngFor="let legacy of legacyList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="legacy.contentType?.titleEn"
                        [textHi]="legacy.contentType?.titleHi"></cbic-static-text>
                </span>
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let legacy of legacyList">
                        <a href="{{legacy.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="legacy.titleEn" [linkTextHi]="legacy.titleHi"
                                [linkEn]="legacy.path" [linkHi]="legacy.path"></cbic-link>
                    </li>
                </ul>
            </div>
           
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Others.svg" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Others</span> -->
                <span *ngFor="let other of otherList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="other.contentType?.titleEn"
                        [textHi]="other.contentType?.titleHi"></cbic-static-text>
                </span>
                
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let other of otherList">
                        <cbic-link [linkTextEn]="other.titleEn" [linkTextHi]="other.titleHi"
                            [linkEn]="other.path" [linkHi]="other.path"></cbic-link>
                    </li>
                </ul>
            </div>
           
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Tax Legislation.svg" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Case Lows</span> -->
                <span *ngFor="let lows of lowsList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="lows.contentType?.titleEn"
                        [textHi]="lows.contentType?.titleHi"></cbic-static-text>
                </span>
                
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let lows of lowsList">
                        <cbic-link [linkTextEn]="lows.titleEn" [linkTextHi]="lows.titleHi"
                            [linkEn]="lows.path" [linkHi]="lows.path"></cbic-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>

<section class="gst-section-black" *ngIf="color === 'bule'">
    <div class="col-lg-11  gst-section mb3  ">
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Tax Legislation.svg" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Tax Legislation</span> -->
                <span *ngFor="let taxLeg of taxLegislationList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="taxLeg.contentType?.titleEn"
                        [textHi]="taxLeg.contentType?.titleHi"></cbic-static-text>
                </span>
                
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let taxLeg of taxLegislationList">
                        <a href="{{taxLeg.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="taxLeg.titleEn" [linkTextHi]="taxLeg.titleHi"
                                [linkEn]="taxLeg.path" [linkHi]="taxLeg.path"></cbic-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Onlines Services.svg" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Online Services</span> -->
                <span *ngFor="let onlineService of onlineServiceList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="onlineService.contentType?.titleEn"
                        [textHi]="onlineService.contentType?.titleHi"></cbic-static-text>
                </span>
               
            </div>
            <div class="custom-scroll-bar" >
                <ul>
                    <li *ngFor="let onlineService of onlineServiceList">
                        <a href="{{onlineService.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="onlineService.titleEn" [linkTextHi]="onlineService.titleHi"
                                [linkEn]="onlineService.path" [linkHi]="onlineService.path"></cbic-link>
                    </li>
                </ul>
            </div>
            
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card   solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/service.png" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Services'Codes,<br>Abatement & Exemption</span> -->
                <span *ngFor="let codes of sericeCodes;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="codes.contentType?.titleEn"
                        [textHi]="codes.contentType?.titleHi"></cbic-static-text>
                </span>
                
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let codes of sericeCodes">
                        <a href="{{codes.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="codes.titleEn" [linkTextHi]="codes.titleHi"
                                [linkEn]="codes.path" [linkHi]="codes.path"></cbic-link>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-lg-11  gst-section">
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card ">
            <div class="gst-card-header ">
               
                <!-- <div class="circle-icon1 circle1"><img src="content/images/GSTIcon.svg" class="img-fluid"></div> -->
                <!-- <span class="text-heading">Legacy Dispute Resolution Scheme,2019 </span> -->
                <span *ngFor="let legacy of legacyList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="legacy.contentType?.titleEn"
                        [textHi]="legacy.contentType?.titleHi"></cbic-static-text>
                </span>
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let legacy of legacyList">
                        <a href="{{legacy.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="legacy.titleEn" [linkTextHi]="legacy.titleHi"
                                [linkEn]="legacy.path" [linkHi]="legacy.path"></cbic-link>
                    </li>
                </ul>
            </div>
            
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Others.svg" class="img-fluid"></div> -->
                <span *ngFor="let other of otherList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="other.contentType?.titleEn"
                        [textHi]="other.contentType?.titleHi"></cbic-static-text>
                </span>
                
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let other of otherList">
                        <a href="{{other.path}}" target="_blank"></a>
                            <cbic-link [linkTextEn]="other.titleEn" [linkTextHi]="other.titleHi"
                                [linkEn]="other.path" [linkHi]="other.path"></cbic-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-xs-12 col-md-6 col-lg-4 card  solution_card">
            <div class="gst-card-header ">
                <!-- <div class="circle-icon1 circle1"><img src="content/images/Tax Legislation.svg" class="img-fluid"></div> -->
                <span *ngFor="let lows of lowsList;let i = index">
                    <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="lows.contentType?.titleEn"
                        [textHi]="lows.contentType?.titleHi"></cbic-static-text>
                </span>
            </div>
            <div class="custom-scroll-bar">
                <ul>
                    <li *ngFor="let lows of lowsList">
                        <cbic-link [linkTextEn]="lows.titleEn" [linkTextHi]="lows.titleHi"
                            [linkEn]="lows.path" [linkHi]="lows.path"></cbic-link>
                    </li>
                </ul>
            </div>
            
        </div>
    </div>
</section>



</section>